import React from 'react';
import { featuredLesson } from '../../lib/appAssets';

/** One octopus adventure, start to finish: story card, question, badge. */
const steps = [{
  number: '01',
  title: 'Read or listen',
  body: 'Explore one big question through short, illustrated story cards, with narration to listen along.',
  art: featuredLesson.heroCard,
  tilt: 'md:-rotate-1'
}, {
  number: '02',
  title: 'Try what you learned',
  body: 'Answer a fun question about your new discovery.',
  question: featuredLesson.quickCheck.question,
  art: featuredLesson.cards[5],
  tilt: 'md:translate-y-4'
}, {
  number: '03',
  title: 'Keep the achievement',
  body: 'Earn a downloadable badge for every adventure you complete.',
  art: featuredLesson.collectible,
  tilt: 'md:rotate-1'
}];
export function FeatureCards() {
  return <section aria-labelledby="steps-heading" className="mt-16 md:mt-24" data-id="element-158" data-mp="58pqthksuodp">
      <div className="mx-auto max-w-xl text-center" data-id="element-159" data-mp="a8lrb6uafxoi">
        <h2 id="steps-heading" className="font-display text-[28px] leading-tight tracking-tight text-ink md:text-[40px]" data-id="element-160" data-mp="323sxue1yul2l">
          A little adventure. A new thing to know.
        </h2>
        <p className="mt-3 text-[18px] text-ink-soft" data-id="element-161" data-mp="2se9d12up0h53">
          Pick a question, explore the answer, and celebrate what you learned.
        </p>
      </div>

      <ol className="mx-auto mt-10 grid max-w-[380px] gap-8 md:max-w-none md:grid-cols-3 md:gap-6 lg:gap-8" data-id="element-162" data-mp="2neeimpbpl9fa">
        {steps.map(step => <li key={step.number} className={step.tilt} data-id="element-163" data-mp="2eehr8fxxpwgj">
            <article className="relative flex h-full flex-col rounded-[28px] bg-white p-3 shadow-lift" data-id="element-164" data-mp="2ecwwoqbmedio">
              <span aria-hidden="true" className="absolute -top-4 left-6 z-10 inline-flex h-10 min-w-[3rem] items-center justify-center rounded-full border-2 border-ink bg-sun px-3 font-display text-[17px] text-ink" data-id="element-165" data-mp="29fx0d74kop4r">
                {step.number}
              </span>
              <div className="flex aspect-[5/6] items-center justify-center rounded-[22px] bg-cream-field p-3" data-id="element-166" data-mp="2mul74n7i7lo">
                <img src={step.art.src} alt={step.art.alt} loading="lazy" decoding="async" width={step.art.width} height={step.art.height} className="aspect-square w-full object-contain" data-id="element-167" data-mp="1x3ci777p1zl5" />
              </div>
              <div className="px-3 pb-4 pt-5" data-id="element-168" data-mp="2fwoul13pubyv">
                <h3 className="font-display text-[23px] leading-snug text-ink" data-id="element-169" data-mp="2ftubbcwfux71">
                  <span className="sr-only" data-id="element-170" data-mp="2ktyoasy519si">Step {step.number}: </span>
                  {step.title}
                </h3>
                <p className="mt-1.5 text-[17px] text-ink-soft" data-id="element-171" data-mp="2awkal13lmz3w">{step.body}</p>
                {'question' in step && step.question && <p className="mt-3 border-l-[3px] border-coral pl-3 text-[16px] leading-snug text-ink" data-id="element-172" data-mp="veqwpira7hk5">
                    <span className="block text-[13px] font-bold text-ink-soft" data-id="element-173" data-mp="zigla87yhz56">Example question</span>
                    <span className="font-display text-[17px]" data-id="element-174" data-mp="rwl1m7l6d6u7">“{step.question}”</span>
                  </p>}
              </div>
            </article>
          </li>)}
      </ol>
    </section>;
}